import { KeycloakInstance } from 'keycloak-js';

import { MINUTES_15 } from '../../constants/timeConstants';
import { Authenticated } from '../keycloakUtils';

export const authenticatedStateMock: Authenticated = {
  status: 'authenticated',
  logout: () => null,
  logoutUrl: '/logout',
  forceUpdateToken: () => null,
  keycloak: null as unknown as KeycloakInstance,
  manageAccountUrl: '/',
  userHasPermissions: () => false,
  userId: '',
  userName: 'Mocked UserName',
  timezone: 'Europe/Bratislava',
  sessionIdleTimeDuration: MINUTES_15,
  locale: 'en-US',
};
